import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";

import { AdminSlim } from "../../models/AdminModel";
import ListCard from "../ListCard";
import { TENANT_DEFINES } from "../../config/defines";

type CadastroAdministradorCardPropsContent = {
	data: AdminSlim;
	skeleton?: never;
};

type CadastroAdministradorCardPropsSkeleton = {
	data?: never;
	onClick?: never;
	onRemove?: never;
	skeleton: true;
};

type CadastroAdministradorCardProps = CadastroAdministradorCardPropsContent | CadastroAdministradorCardPropsSkeleton;

export default function CadastroAdministradorCard(props: CadastroAdministradorCardProps) {
	const navigate = useNavigate();

	function handleClick() {
		if (!props.skeleton && props.data) {
			navigate("/cadastroAdministradorFormulario/" + props.data.id);
		}
	}

	let skeletonButton = "";
	if (props.skeleton) {
		skeletonButton = "skeleton skeleton-button";
	}

	return (
		<>
			<ListCard onClick={handleClick}>
				<ListCard.Content>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Nome</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.nome ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>{TENANT_DEFINES[`${process.env.REACT_APP_TENANT}`].empresa}</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.empresa.nome ?? "..."}</ListCard.Text>
					</ListCard.Item>
				</ListCard.Content>
				<ListCard.Action>
					<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
				</ListCard.Action>
			</ListCard>
		</>
	);
}
